(()=>{const root=document.documentElement;root.classList.add('gj-js');const reduced=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;function init(){let bar=document.getElementById('gj-scroll-progress');if(!bar){bar=document.createElement('div');bar.id='gj-scroll-progress';document.body.appendChild(bar)}const update=()=>{const h=document.documentElement.scrollHeight-innerHeight,p=h>0?Math.min(1,scrollY/h):0;bar.style.width=(p*100)+'%';root.classList.toggle('gj-scrolled',scrollY>18)};update();addEventListener('scroll',update,{passive:true});addEventListener('resize',update,{passive:true});const items=[...document.querySelectorAll('[data-gj-reveal],.gj-reveal')];items.forEach(el=>el.classList.add('gj-reveal'));if(reduced){items.forEach(el=>el.classList.add('is-visible'));return}const io=new IntersectionObserver(es=>es.forEach(e=>{if(e.isIntersecting){e.target.classList.add('is-visible');io.unobserve(e.target)}}),{rootMargin:'0px 0px -8% 0px',threshold:.08});items.forEach(el=>io.observe(el))}document.readyState==='loading'?document.addEventListener('DOMContentLoaded',init,{once:true}):init()})();

/* GIJOS PREMIUM V2 PRODUCT GALLERY */
(()=>{function init(){
  const products=[...document.querySelectorAll('.gijos-product')];
  if(!products.length)return;
  let box=document.querySelector('.gj-product-lightbox');
  if(!box){
    box=document.createElement('div');
    box.className='gj-product-lightbox';
    box.setAttribute('role','dialog');
    box.setAttribute('aria-modal','true');
    box.setAttribute('aria-label','Productafbeelding vergroten');
    box.innerHTML='<button class="gj-product-lightbox__close" type="button" aria-label="Sluiten">×</button><img class="gj-product-lightbox__img" alt="">';
    document.body.appendChild(box);
  }
  const zoomImg=box.querySelector('.gj-product-lightbox__img');
  const close=()=>{box.classList.remove('is-open');document.documentElement.classList.remove('gj-lightbox-open');zoomImg.removeAttribute('src')};
  box.querySelector('.gj-product-lightbox__close')?.addEventListener('click',close);
  box.addEventListener('click',e=>{if(e.target===box)close()});
  document.addEventListener('keydown',e=>{if(e.key==='Escape'&&box.classList.contains('is-open'))close()});
  const open=img=>{
    if(!img)return;
    zoomImg.src=img.currentSrc||img.src;
    zoomImg.alt=img.alt||'Productafbeelding';
    box.classList.add('is-open');
    document.documentElement.classList.add('gj-lightbox-open');
    box.querySelector('.gj-product-lightbox__close')?.focus();
  };
  products.forEach(root=>{
    const main=root.querySelector('[data-gallery-main]');
    if(!main)return;
    const slides=[...root.querySelectorAll('[data-media-id]')];
    const thumbs=[...root.querySelectorAll('[data-thumb-media-id]')];
    let downX=0,downY=0,dragged=false,raf=0;
    const sync=()=>{
      raf=0;
      if(innerWidth>749||!slides.length)return;
      const center=main.scrollLeft+main.clientWidth/2;
      let active=slides[0],dist=Infinity;
      slides.forEach(slide=>{const d=Math.abs((slide.offsetLeft+slide.offsetWidth/2)-center);if(d<dist){dist=d;active=slide}});
      const id=active?.dataset.mediaId;
      if(!id)return;
      slides.forEach(slide=>slide.classList.toggle('is-active',slide===active));
      thumbs.forEach(thumb=>thumb.classList.toggle('is-active',String(thumb.dataset.thumbMediaId)===String(id)));
    };
    main.addEventListener('scroll',()=>{if(!raf)raf=requestAnimationFrame(sync)},{passive:true});
    main.addEventListener('pointerdown',e=>{downX=e.clientX;downY=e.clientY;dragged=false},{passive:true});
    main.addEventListener('pointermove',e=>{if(Math.hypot(e.clientX-downX,e.clientY-downY)>8)dragged=true},{passive:true});
    slides.forEach(slide=>{
      const img=slide.querySelector('img');
      if(!img)return;
      slide.tabIndex=0;
      slide.setAttribute('role','button');
      slide.setAttribute('aria-label',(img.alt||'Productafbeelding')+' vergroten');
      slide.addEventListener('click',()=>{if(!dragged)open(img)});
      slide.addEventListener('keydown',e=>{if(e.key==='Enter'||e.key===' '){e.preventDefault();open(img)}});
    });
    thumbs.forEach(thumb=>thumb.addEventListener('click',()=>{
      if(innerWidth>749)return;
      const slide=slides.find(x=>String(x.dataset.mediaId)===String(thumb.dataset.thumbMediaId));
      slide?.scrollIntoView({behavior:'smooth',block:'nearest',inline:'center'});
    }));
    sync();
  });
}
document.readyState==='loading'?document.addEventListener('DOMContentLoaded',init,{once:true}):init()})();

/* GIJOS PREMIUM V3 MOBILE HOME */
(()=>{function init(){
  const root=document.documentElement;
  const path=location.pathname||'/';
  const isHome=path==='/';
  const isProduct=path.startsWith('/products/');
  root.classList.toggle('gj-home',isHome);
  if(path.startsWith('/products/'))return;
  if(isHome||isProduct)return;
  if(document.querySelector('.gj-mobile-dock'))return;
  const nav=document.createElement('nav');
  nav.className='gj-mobile-dock';
  nav.setAttribute('aria-label','Snelle navigatie');
  const items=[
    ['/','Home','<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 11.5 12 4l9 7.5"/><path d="M5.5 10.5V20h13v-9.5"/><path d="M9.5 20v-5h5v5"/></svg>',()=>path==='/'],
    ['/collections/all','Shop','<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 8h14l-1 12H6L5 8Z"/><path d="M9 8V6a3 3 0 0 1 6 0v2"/></svg>',()=>path.startsWith('/collections')||path.startsWith('/products')],
    ['/search','Zoeken','<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="10.5" cy="10.5" r="6.5"/><path d="m16 16 5 5"/></svg>',()=>path.startsWith('/search')],
    ['/cart','Mandje','<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 4h2l2.2 10.2a2 2 0 0 0 2 1.6h7.9a2 2 0 0 0 1.9-1.4L21 8H6"/><circle cx="10" cy="20" r="1"/><circle cx="18" cy="20" r="1"/></svg>',()=>path.startsWith('/cart')]
  ];
  nav.innerHTML=items.map(([href,label,icon,isActive])=>'<a class="gj-mobile-dock__item'+(isActive()?' is-active':'')+'" href="'+href+'">'+icon+'<span>'+label+'</span></a>').join('');
  document.body.appendChild(nav);
}
document.readyState==='loading'?document.addEventListener('DOMContentLoaded',init,{once:true}):init()})();

/* GIJOS PREMIUM V13 HOME REVEALS */
(()=>{function init(){
  if(location.pathname!=='/')return;
  const reduced=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const selectors=[
    '.gijos-circles__head',
    '.gijos-circle',
    '.gijos-spotlight__media-column',
    '.gijos-spotlight__content-column',
    '.gj-week-media',
    '.gj-week-content',
    '.gijos-product-grid__header',
    '.gijos-product-card',
    '.gj-journey-head',
    '.gj-step',
    '.gj-journey-cta',
    '.gijos-why__head',
    '.gijos-why__item'
  ];
  const els=[...document.querySelectorAll(selectors.join(','))];
  els.forEach((el,i)=>{
    el.classList.add('gj-home-reveal');
    el.style.transitionDelay=((i%6)*45)+'ms';
  });
  if(reduced){els.forEach(el=>el.classList.add('is-visible'));return;}
  const io=new IntersectionObserver(entries=>{
    entries.forEach(entry=>{
      if(entry.isIntersecting){
        entry.target.classList.add('is-visible');
        io.unobserve(entry.target);
      }
    });
  },{rootMargin:'0px 0px -6% 0px',threshold:.06});
  els.forEach(el=>io.observe(el));
}
document.readyState==='loading'?document.addEventListener('DOMContentLoaded',init,{once:true}):init()})();

/* GIJOS V35 HOMEPAGE MOTION START */
(()=>{function init(){
  if(location.pathname!=='/')return;
  const reduced=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  document.querySelectorAll('[data-gj-reveal]').forEach((el,i)=>{
    const raw=Number(el.dataset.gjDelay||0);
    const delay=Math.min(5,Math.max(0,raw))*70;
    if(!reduced&&delay) el.style.transitionDelay=delay+'ms';
  });

  if(reduced||!window.matchMedia('(hover:hover) and (pointer:fine)').matches)return;
  const hero=document.querySelector('.gj-hero-split');
  const visual=hero?.querySelector('.gj-hero-split__visual');
  const image=hero?.querySelector('.gj-hero-split__image');
  if(!hero||!visual||!image)return;

  let raf=0;
  hero.addEventListener('pointermove',e=>{
    const rect=hero.getBoundingClientRect();
    const x=((e.clientX-rect.left)/rect.width-.5);
    const y=((e.clientY-rect.top)/rect.height-.5);
    cancelAnimationFrame(raf);
    raf=requestAnimationFrame(()=>{
      visual.style.setProperty('--gj-hero-x',(x*7).toFixed(2)+'px');
      visual.style.setProperty('--gj-hero-y',(y*5).toFixed(2)+'px');
      image.style.setProperty('--gj-img-x',(x*-5).toFixed(2)+'px');
      image.style.setProperty('--gj-img-y',(y*-4).toFixed(2)+'px');
    });
  });
  hero.addEventListener('pointerleave',()=>{
    visual.style.setProperty('--gj-hero-x','0px');
    visual.style.setProperty('--gj-hero-y','0px');
    image.style.setProperty('--gj-img-x','0px');
    image.style.setProperty('--gj-img-y','0px');
  });
}
document.readyState==='loading'?document.addEventListener('DOMContentLoaded',init,{once:true}):init()})();
/* GIJOS V35 HOMEPAGE MOTION END */

/* GIJOS V36 WHATSAPP SAFE OPEN START */
(()=>{function init(){
  function cleanPhone(value){return String(value||'').replace(/\D/g,'')}

  function showEditorNotice(){
    let notice=document.getElementById('gj-whatsapp-editor-notice');
    if(!notice){
      notice=document.createElement('div');
      notice.id='gj-whatsapp-editor-notice';
      notice.className='gj-whatsapp-editor-notice';
      notice.setAttribute('role','status');
      notice.innerHTML='<button type="button" aria-label="Melding sluiten">×</button><strong>WhatsApp testen</strong><span>WhatsApp kan niet binnen de Shopify editor openen. Gebruik <b>Preview in nieuw tabblad</b> om deze knop te testen.</span>';
      document.body.appendChild(notice);
      notice.querySelector('button')?.addEventListener('click',()=>notice.classList.remove('is-visible'));
    }
    notice.classList.add('is-visible');
    clearTimeout(window.__gjWaNoticeTimer);
    window.__gjWaNoticeTimer=setTimeout(()=>notice.classList.remove('is-visible'),6500);
  }

  window.gijosOpenWhatsApp=function(phone,message){
    const number=cleanPhone(phone);
    const text=encodeURIComponent(message||'');
    const designMode=Boolean(window.Shopify&&Shopify.designMode);

    if(designMode){
      showEditorNotice();
      return false;
    }

    const url='https://wa.me/'+number+(text?'?text='+text:'');
    const opened=window.open(url,'_blank','noopener,noreferrer');
    if(opened)try{opened.opener=null}catch(e){}
    return false;
  };

  document.addEventListener('click',function(e){
    const link=e.target.closest('a[href*="wa.me/"]');
    if(!link)return;

    const designMode=Boolean(window.Shopify&&Shopify.designMode);
    if(!designMode)return;

    e.preventDefault();
    e.stopPropagation();
    showEditorNotice();
  },true);
}
document.readyState==='loading'?document.addEventListener('DOMContentLoaded',init,{once:true}):init()})();
/* GIJOS V36 WHATSAPP SAFE OPEN END */
